import IGuid = System.IGuid;

export enum SensorPlanBookType {
  NFertilizationPlanBook = 0,
  PlanProtectionPlanBook = 1
}

export type SensorDataPlanBookInfo = {
  PlanBookId: IGuid | undefined;
  Type: SensorPlanBookType | undefined;
};

